import { Component, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ClaimInquireModal } from '../../models/ClaimInquireModal.model';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOption, MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-claim-inquire-modal',
  templateUrl: './claim-inquire-modal.component.html',
  styleUrls: ['./claim-inquire-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOption,
    MatButtonModule,
    MatSelectModule,
    MatOptionModule,
    MatDialogModule
  ]
})
export class ClaimInquireModalComponent implements OnInit {

  form!: FormGroup;
  email!: string;
  questionAbout!: any;
  comment!: string;
  sendEnabled = false;

  constructor(
    public dialogRef: MatDialogRef<ClaimInquireModalComponent>,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      questionAbout: ['', Validators.required],
      comment: ['', [Validators.required, Validators.pattern(/[\S]/)]]
    });
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSendClick(): void {
    const claimInquireModalData: ClaimInquireModal = {
      email: this.form.get('email')?.value,
      questionAbout: this.form.get('questionAbout')?.value,
      comment: this.form.get('comment')?.value
    }
    this.dialogRef.close(claimInquireModalData);
  }

  isSendEnabled(): boolean {
    return this.form.valid;
  }
}